import React from 'react';
import { useHistory } from 'react-router-dom';
/* Components */
import { Button } from '../Button';

export const HiddenButton = ({ submitEvent, innerRef }) => {
  return (
    <>
      <Button innerRef={innerRef} isRecap={true} color="white" type="hidden" text="Prosegui" clickEvent={ submitEvent }/>
    </>
  );
}
